import PropTypes from 'prop-types';
import React from 'react';

import { datastoreComponentConnect } from './DatastoreComponentMixin.jsx';

import { mapUnit } from '../util/topic.js';

export default class OutletGroupHeader extends React.Component {
    static contextTypes = {
        t: PropTypes.func.isRequired,
        p: PropTypes.object.isRequired
    }

    state = {
        counter: 0
    };

    subs = {};

    updateInletInDS = (value) => {
        // Just invalidate state so we re-render
        this.setState({counter: this.state.counter + 1});
    }

    isInterestingInlet(inlet) {
        return (inlet.parent || (inlet.type && inlet.type !== "SINGLE" && inlet.type !== "SUM" && inlet.name !== undefined));
    }

    subscribeInletAndParents(inletPath) {
        let inletData = this.context.p.getPath(inletPath);

        while (inletData) {
            if (!this.isInterestingInlet(inletData)) {
                break;
            }

            // Subscribe inlet topic itself for name changes and so on
            if (this.subs[inletPath] === undefined) {
                this.subs[inletPath] = this.context.p.subscribeDS(inletPath, this.updateInletInDS);
            }
            // Also subscribe to changes in monitored attribute
            const attrPath = inletPath + "/" + this.props.inletField;
            if (this.subs[attrPath] === undefined) {
                this.subs[attrPath] = this.context.p.subscribeDS(attrPath, this.updateInletInDS);
            }

            if (inletData.parent) {
                inletPath = this.props.basePath + inletData.parent;
                inletData = this.context.p.getPath(inletPath);
            } else {
                break;
            }
        }

        // TODO: unsubscribe paths that were subscribed but are now no longer needed? or ignore?
        
        this.setState({
            counter: this.state.counter + 1
        });        
    }

    componentDidMount() {
        this.subscribeInletAndParents(this.props.basePath + this.props.inletPath);
    }

    componentWillUnmount() {
        for (let subPath in this.subs) {
            const sub = this.subs[subPath];
            this.context.p.unsubscribeDS(this.updateInletInDS, sub);
        }
        this.subs = {};
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.inletPath !== this.props?.inletPath) {
            subscribeInletAndParents(nextProps.inletPath);
        }
    }
    
    render() {
        let labels = [];
        let inletPath = this.props.basePath + this.props.inletPath;
        let inlet;

        while (inlet = this.context.p.getPath(inletPath)) {
            if (!this.isInterestingInlet(inlet)) {
                break;
            }
            let value = this.context.p.getPath(inletPath + "/" + this.props.inletField);

            if (value && value.v !== undefined) {
                value = value.v;
            }

            let line;
            if (inlet.phase) {
                line = this.context.t("sensor_sub_types.phase") + " \"" + inlet.phase?.toLowerCase() + "\"";
            } else {
                if (inlet.type) {
                    line = this.context.t("sensor_sub_types." + inlet.type?.toLowerCase());
                    if (inlet.name) {
                        line += " \"" + inlet.name + "\"";
                    }
                }
            }
            if (line) {
                let unit = null;
                let valueItem = null;

                if (value !== undefined) {
                    if (this.props.dataRound !== undefined) {
                        value = parseFloat(value).toFixed(this.props.dataRound !== undefined ? this.props.dataRound : 2);
                    }

                    if (mapUnit[this.props.inletField]) {
                        if (this.props.renderPlain) {
                            unit = mapUnit[this.props.inletField];
                        } else {
                            unit = (
                                <span className="unit">&nbsp;{mapUnit[this.props.inletField]}</span>
                            );
                        }
                    }

                    if (this.props.renderPlain) {
                        valueItem = (
                            <>
                                <br />
                                { value } {unit}
                            </>
                        );
                    } else {
                        valueItem = (
                            <span>{value} {unit}</span>
                        );
                        }
                }
                labels.push((
                    <React.Fragment key={inletPath}>
                        {line}{valueItem}
                        <br></br>
                    </React.Fragment>
                ));
            }
            if (inlet.parent) {
                inletPath = this.props.basePath + inlet.parent;
            } else {
                break;
            }
        }

        return (
            <td className="outletGroupHeader" rowSpan={this.props.numOutlets}>{ labels }</td>
        );
    }
}

OutletGroupHeader.proptypes = {
    numOutlets: PropTypes.number,
    inletPath: PropTypes.string,
    inletField: PropTypes.string,
    basePath: PropTypes.string.isRequired,
    renderPlain: PropTypes.boolean
}

// export default datastoreComponentConnect(OutletGroupHeader);
